import { render, staticRenderFns } from "./TianyiDirectRequests.vue?vue&type=template&id=5f93eb49&scoped=true"
import script from "./TianyiDirectRequests.vue?vue&type=script&lang=js"
export * from "./TianyiDirectRequests.vue?vue&type=script&lang=js"
import style0 from "./TianyiDirectRequests.vue?vue&type=style&index=0&id=5f93eb49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f93eb49",
  null
  
)

export default component.exports